module.exports = __webpack_public_path__ + "static/media/pencil.7eee4981.svg";